import { render, staticRenderFns } from "./SplitScreenSetting.vue?vue&type=template&id=1979e257"
import script from "./SplitScreenSetting.vue?vue&type=script&lang=js"
export * from "./SplitScreenSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports